module.exports = __webpack_public_path__ + "img/logo.dedf296f.png";